import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const C = { primary:"#f97316", dark:"#ea580c", white:"#ffffff", bg:"#f2f2f7", text:"#1c1c1e", sub:"#6b7280", border:"#e5e7eb" };

function Section({ title, children }) {
  return (
    <div style={{ background:C.white, borderRadius:16, padding:"20px", marginBottom:14, border:`1px solid ${C.border}` }}>
      <div style={{ fontFamily:"'Fraunces',serif", fontWeight:800, fontSize:"1rem", marginBottom:10, color:C.dark }}>{title}</div>
      <div style={{ fontSize:"0.85rem", color:C.sub, lineHeight:1.8 }}>{children}</div>
    </div>
  );
}

export default function TermsAndConditions() {
  const navigate = useNavigate();
  return (
    <div style={{ fontFamily:"'Plus Jakarta Sans',system-ui,sans-serif", background:C.bg, minHeight:"100vh", color:C.text }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,800;9..144,900&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}`}</style>

      <div style={{ background:C.white, borderBottom:`1px solid ${C.border}`, padding:"14px 20px", display:"flex", alignItems:"center", gap:12, position:"sticky", top:0, zIndex:10 }}>
        <button onClick={() => navigate(-1)} style={{ background:"none", border:"none", cursor:"pointer", display:"flex" }}><ArrowLeft size={22} color={C.text}/></button>
        <div style={{ fontFamily:"'Fraunces',serif", fontWeight:900, fontSize:"1.15rem" }}>Terms & Conditions</div>
      </div>

      <div style={{ maxWidth:640, margin:"0 auto", padding:"24px 20px 48px" }}>

        <div style={{ background:`linear-gradient(135deg,${C.dark},${C.primary})`, borderRadius:16, padding:"20px 24px", marginBottom:20 }}>
          <div style={{ color:"#fff", fontWeight:800, fontSize:"1rem", marginBottom:4 }}>Terms & Conditions — Quickry</div>
          <div style={{ color:"rgba(255,255,255,0.8)", fontSize:"0.78rem" }}>Last updated: January 2025 | Please read carefully before using our services</div>
        </div>

        <Section title="1. Acceptance of Terms">
          By accessing or using the Quickry platform (website or mobile application), you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services. These terms apply to all users including customers, vendors, and delivery partners.
        </Section>

        <Section title="2. About Quickry">
          Quickry is a hyperlocal delivery platform operating in Akola, Maharashtra, India. We facilitate connections between customers and local restaurants, grocery stores, courier services, and pharmacies. Quickry acts as an intermediary platform and is not itself a restaurant, store, or courier service.
        </Section>

        <Section title="3. User Accounts">
          • You must provide accurate, complete information when creating an account.<br/>
          • You are responsible for maintaining the confidentiality of your account credentials.<br/>
          • You must be at least 18 years old to create an account.<br/>
          • You are responsible for all activities that occur under your account.<br/>
          • Quickry reserves the right to suspend or terminate accounts that violate these terms.
        </Section>

        <Section title="4. Ordering & Payments">
          • Orders placed through Quickry are subject to acceptance by the respective restaurant or store.<br/>
          • Prices displayed are inclusive of applicable taxes unless stated otherwise.<br/>
          • Delivery charges and platform fees apply as displayed at checkout.<br/>
          • Payments are processed securely through Paytm Payment Gateway.<br/>
          • By placing an order, you authorize Quickry to charge the specified amount.<br/>
          • Cash on Delivery (COD) is available for select orders and areas.
        </Section>

        <Section title="5. Delivery">
          • Estimated delivery times are indicative and not guaranteed.<br/>
          • Delivery times may vary due to weather, traffic, or high demand.<br/>
          • You must be available at the delivery address. In case of failed delivery, charges may apply.<br/>
          • Delivery is currently available within Akola city limits only.<br/>
          • Quickry is not liable for delays caused by circumstances beyond our control.
        </Section>

        <Section title="6. Cancellation Policy">
          • Orders may be cancelled within 2 minutes of placement at no charge.<br/>
          • Once a restaurant/store accepts your order, cancellation may not be possible.<br/>
          • Quickry reserves the right to cancel orders due to unavailability, pricing errors, or fraud detection.<br/>
          • Refer to our Refund Policy for details on refunds upon cancellation.
        </Section>

        <Section title="7. Prohibited Activities">
          Users must not:<br/>
          • Provide false or misleading information<br/>
          • Use the platform for any unlawful purpose<br/>
          • Attempt to hack, disrupt, or abuse the platform<br/>
          • Place fraudulent orders or abuse refund policies<br/>
          • Harass or threaten delivery partners, vendors, or support staff
        </Section>

        <Section title="8. Intellectual Property">
          All content on the Quickry platform including logos, text, images, and software is owned by or licensed to Quickry. You may not reproduce, distribute, or create derivative works without our express written permission.
        </Section>

        <Section title="9. Limitation of Liability">
          To the maximum extent permitted by law, Quickry shall not be liable for any indirect, incidental, or consequential damages arising from your use of the platform. Our total liability shall not exceed the amount paid by you for the specific order in question.
        </Section>

        <Section title="10. Governing Law">
          These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Akola, Maharashtra.
        </Section>

        <Section title="11. Changes to Terms">
          We may modify these Terms at any time. Continued use of the platform after changes constitutes acceptance of the new terms.
        </Section>

        <Section title="12. Contact">
          For any questions regarding these Terms, contact us at:<br/><br/>
          <strong style={{ color:C.text }}>Email:</strong> hello.quickry@gmail.com<br/>
          <strong style={{ color:C.text }}>Address:</strong> Near Khandelwall School Old city Dabki Road, Akola, Maharashtra — 444001, India
        </Section>

      </div>
    </div>
  );
}